import StarsRating from "./stars-rating";
import { interpolate } from "utils/interpolate";
import { useDictionary } from "hooks/use-dictionary";
import { ComponentProps } from "react";
import classNames from "classnames";
import { PublicProgram } from "types/program";
import dayjs from "dayjs";
import { normalizeExternalUrl } from "utils/normalize-external-url";
import TagBase from "./tag-base";

interface ProgramCardProps extends ComponentProps<"div"> {
  program: PublicProgram;
}

const ProgramCard = ({ program, className, ...props }: ProgramCardProps) => {
  const dict = useDictionary();
  return (
    <div className={classNames("space-border bg-white p-4 rounded space-y-1 break-words", className)} {...props}>
      <div className="flex"></div>
      <div className="flex justify-between text-lg">
        <div className="text-lg line-clamp-4">{program.name}</div>
        <div>{program.identification}</div>
      </div>
      <div className="text-sm text-theme-gray300">{program.organizerInstitution.name}</div>
      {program.organizerInstitution.website && (
        <div className="text-sm text-theme-gray300 break-all">{normalizeExternalUrl(program.organizerInstitution.website)}</div>
      )}
      {program.dateTo && program.confirmationDate && (
        <div className="text-lg line-clamp-4">
          {dayjs(program.confirmationDate).format("YYYY-MM-DD")} - {dayjs(program.dateTo).format("YYYY-MM-DD")}
        </div>
      )}
      <StarsRating reviews={program.reviewRating} />
      <div className="flex justify-between text-lg">
        <div>
          {interpolate(dict.organizerAdmin.events.durationValue, {
            value: `${program.duration ?? program.durationSum}`,
          })}
        </div>
      </div>
      {program.dateTo && dayjs(program.dateTo).isBefore(dayjs(), "day") && (
        <div className="mt-2 inline-block">
          <TagBase className="bg-theme-gray50 text-theme-gray300">{dict.common.expiredTag}</TagBase>
        </div>
      )}
    </div>
  );
};

export default ProgramCard;
